import { Record } from "../../fable_modules/fable-library.3.7.12/Types.js";
import { record_type, array_type, option_type, bool_type, int32_type, string_type, class_type } from "../../fable_modules/fable-library.3.7.12/Reflection.js";

export class SessionAnnotationViewModel extends Record {
    constructor(sessionId, annotationId, annotationData, streamPathIndex, sliceIndex, macro, note, annotationName, measurements) {
        super();
        this.sessionId = sessionId;
        this.annotationId = annotationId;
        this.annotationData = annotationData;
        this.streamPathIndex = (streamPathIndex | 0);
        this.sliceIndex = (sliceIndex | 0);
        this.macro = macro;
        this.note = note;
        this.annotationName = annotationName;
        this.measurements = measurements;
    }
}

export function SessionAnnotationViewModel$reflection() {
    return record_type("Optiscan.Models.View.SessionAnnotationViewModel.SessionAnnotationViewModel", [], SessionAnnotationViewModel, () => [["sessionId", class_type("System.Guid")], ["annotationId", string_type], ["annotationData", string_type], ["streamPathIndex", int32_type], ["sliceIndex", int32_type], ["macro", bool_type], ["note", option_type(string_type)], ["annotationName", option_type(string_type)], ["measurements", array_type(string_type)]]);
}

export function SessionAnnotationViewModel_get_note_() {
    return [(m) => m.note, (v) => ((m_1) => (new SessionAnnotationViewModel(m_1.sessionId, m_1.annotationId, m_1.annotationData, m_1.streamPathIndex, m_1.sliceIndex, m_1.macro, v, m_1.annotationName, m_1.measurements)))];
}

export function SessionAnnotationViewModel_get_annotationName_() {
    return [(m) => m.annotationName, (v) => ((m_1) => (new SessionAnnotationViewModel(m_1.sessionId, m_1.annotationId, m_1.annotationData, m_1.streamPathIndex, m_1.sliceIndex, m_1.macro, m_1.note, v, m_1.measurements)))];
}

